import {
  Box,
  Checkbox,
  FormControlLabel,
  TextField,
  Typography,
  Tooltip,
  Dialog,
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import customStyles from "app/shared-components/SelectCustomStyle";
import { memo, useContext, useEffect, useState, useMemo ,useRef} from "react";
import Select, { components } from "react-select";
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import { SelectedStatus } from "./OrderList";
const aoRoReasonsUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.aoRoReasons}`;
const usersUrl = `${process.env.REACT_APP_API_KEY_URL}${oAuthServiceConfig.users}`;

const MAX_VISIBLE = 2;

const LimitedMultiValue = (props) => {
  const { index, getValue } = props;
  const total = getValue().length;

  if (index < MAX_VISIBLE) return <components.MultiValue {...props} />;
  if (index === MAX_VISIBLE) {
    return (
      <div
        style={{
          fontSize: 10,
          padding: "0 6px",
          whiteSpace: "nowrap",
          opacity: 0.8,
          flexShrink: 0,
        }}
      >
        +{total - MAX_VISIBLE} more
      </div>
    );
  }
  return null;
};

const extend = (styles, key, override) => (base, state) => ({
  ...(styles?.[key] ? styles[key](base, state) : base),
  ...override,
});

const MultiSelectWithModal = ({
  title,
  name,
  options,
  filter,
  onChange, 
  styles,
  isDisabled = false,
  noOptionsMessage,
  wrapperClassName = "flex-1",
}) => {
  const [open, setOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const timerRef = useRef(null);

  const selected = options.filter((obj) =>
    (filter?.[name] || []).includes(obj.value),
  );

  const handleMouseEnter = () => {
    if (isDisabled || selected.length < 2 || menuOpen || open) return;
    timerRef.current = setTimeout(() => setOpen(true), 500);
  };

  const handleMouseLeave = () => clearTimeout(timerRef.current);

  useEffect(() => () => clearTimeout(timerRef.current), []);

  const inlineStyles = {
    ...styles,
    valueContainer: extend(styles, "valueContainer", {
      flexWrap: "nowrap",
      overflow: "hidden",
    }),
    multiValue: extend(styles, "multiValue", {
      width: "auto",
      maxWidth: "40%",
      flexShrink: 1,
      minWidth: 0,
    }),
  };

  const modalStyles = {
    ...styles,
    control: extend(styles, "control", {
      height: "auto",
      minHeight: 36,
      alignItems: "flex-start",
    }),
    valueContainer: extend(styles, "valueContainer", {
      height: "auto",
      maxHeight: 180,
      flexWrap: "wrap",
      overflowY: "auto",
      padding: "4px",
    }),
    indicatorsContainer: extend(styles, "indicatorsContainer", {
      height: "auto",
      alignSelf: "stretch",
    }),
    multiValue: extend(styles, "multiValue", {
      width: "auto",
      maxWidth: "100%",
      flexShrink: 0,
    }),
    multiValueLabel: extend(styles, "multiValueLabel", {
      fontSize: "11px",
      padding: "3px 6px",
    }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  };

  return (
    <>
      <Box
        className={wrapperClassName}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <Tooltip title={title} arrow>
          <div>
            <Select
              placeholder={title}
              name={name}
              value={selected}
              onChange={(e) => onChange(e, name)}
              isMulti
              options={options}
              isDisabled={isDisabled}
              noOptionsMessage={noOptionsMessage}
              styles={inlineStyles}
              components={{ MultiValue: LimitedMultiValue }}
              menuPortalTarget={document.body}
              onMenuOpen={() => {
                clearTimeout(timerRef.current);
                setMenuOpen(true);
              }}
              onMenuClose={() => setMenuOpen(false)}
            />
          </div>
        </Tooltip>
      </Box>

      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>
          {title} ({selected.length} selected)
        </DialogTitle>
        <DialogContent sx={{ minHeight: 300, pt: 1 }}>
          <Select
            placeholder={`Add ${title}`}
            name={`${name}-modal`}
            value={selected}
            onChange={(e) => onChange(e, name)}
            isMulti
            autoFocus
            options={options}
            isDisabled={isDisabled}
            noOptionsMessage={noOptionsMessage}
            styles={modalStyles}
            menuPortalTarget={document.body}
            menuPlacement="auto"
          />
        </DialogContent>
        <DialogActions>
          <Button color="secondary" onClick={() => setOpen(false)}>
            Done
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};;
const AdvancedSearch = ({
  filter,
  setFilter,
  hasCustomerRole,
  hasSopAdminRole,
  vendorId,
  rangeId,
  setRangeId,
  custCountry,
}) => {
  const theme = useTheme();
  const [orderCategoryOptions, setOrderCategoryOptions] = useState([]);
  const [territoryOptions, setTerritoryOptions] = useState([]);
  const [reginOptions, setReginOptions] = useState([]);
  const [priceGroupOptions, setPriceGroupOptions] = useState([]);
  const [rangeOptions, setRangeOptions] = useState([]);
  const [frontColorOptions, setFrontColorOptions] = useState([]);
  const [carcassOptions, setCarcassOptions] = useState([]);
  const [handleOptions, setHandleOptions] = useState([]);
  const [portOptions, setPortOptions] = useState([]);
  const [countryOptions, setCountryOptions] = useState([]);
  const [selectStatus, setSelectStatus] = useContext(SelectedStatus);
  const [modeOfShipmentOptions, setModeOfShipmentOptions] = useState([]);
  const [userOptions, setUserOptions] = useState([]);
  const [reasons, setReasons] = useState([]);

  const OrderTypeOptions = [
    { label: "ALL", value: "ALL" },
    { label: "SO", value: "SO" },
    { label: "AO", value: "AO" },
    { label: "PI", value: "PI" },
  ];

  const categoryGroupOptions = [
    { label: "ALL", value: "ALL" },
    { label: "RET", value: "RET" },
    { label: "PRJ", value: "PRJ" },
  ];

  const StatusOptions = [
    { label: "Yes", value: "yes" },
    { label: "No", value: "no" },
  ];

  const statusMultiOptions = [
    { value: "WAITING", label: "WAITING" },
    { value: "PENDING", label: "PENDING" },
    { value: "APPROVED", label: "APPROVED" },
    { value: "REJECTED", label: "REJECTED" },
    { value: "DECLINED", label: "DECLINED" },
  ];

  const handleChange = (event) => {
    setFilter({
      ...filter,
      [event.target.name]: event.target.value,
    });
  };

  const handleTypeChange = (data, action, key) => {
    let value;
    if (action.action === "clear") {
      value = key === "categoryGroup" ? null : "";
    } else {
      value = data.value;
    }

    if (key === "mainRange") {
      setRangeId(action.action === "clear" ? null : data.id);
      setFilter({
        ...filter,
        [key]: action.action === "clear" ? [] : [data.label],
      });
    } else {
      setFilter({ ...filter, [key]: value });
    }
  };

  const handleMuiltyChange = (data, name) => {
    if (data) {
      if (name === "listPort" || name === "mainHandle") {
        const filterValues = data.map((row) => row.label);
        setFilter({ ...filter, [name]: filterValues });
      } else if (name === "partOrderReason") {
        const filterValues = data.map((row) => row.value);

        const validSubs = new Set(
          reasons
            .filter((r) => filterValues.includes(r.value))
            .flatMap((r) => r.subReasons || []),
        );

        setFilter({
          ...filter,
          partOrderReason: filterValues,
          partOrderSubReason: (filter.partOrderSubReason || []).filter((s) =>
            validSubs.has(s),
          ),
        });
      } else {
        const filterValues = data.map((row) => row.value);
        setFilter({ ...filter, [name]: filterValues });
      }
    }
  };

  useEffect(() => {
    setFilter({ ...filter, orderStatus2: selectStatus });
  }, [selectStatus]);

  const fetchData = async (
    url,
    mapFunction,
    setOptionsFunction,
    mapCallback,
  ) => {
    try {
      const list = await OAuthService.getList(`${url}?sort=id,asc&size=1000`);
      const data = list?.data;
      if (data) {
        let options = [];
        if (mapFunction && data?._embedded && data._embedded[mapFunction]) {
          options = data._embedded[mapFunction].map(mapCallback);
        } else if (data?._embedded) {
          const firstKey = Object.keys(data._embedded)[0];
          if (Array.isArray(data._embedded[firstKey])) {
            options = data._embedded[firstKey].map(mapCallback);
          }
        } else if (Array.isArray(data)) {
          options = data.map(mapCallback);
        }
        setOptionsFunction(options);
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  const getOrderCategory = () => {
    const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.orderCategories}`;
    const mapCallback = (orderCategory) => ({
      label: orderCategory.name,
      value: orderCategory.name,
    });
    fetchData(url, "orderCategories", setOrderCategoryOptions, mapCallback);
  };

  const getTerritory = () => {
    const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.territory}`;
    const mapCallback = (territory) => ({
      label: `T${territory.id}`,
      value: territory.id,
    });
    fetchData(
      url,
      "territories",
      (options) => {
        const sorted = (options || []).sort(
          (a, b) => Number(a.value) - Number(b.value),
        );
        setTerritoryOptions(sorted);
      },
      mapCallback,
    );
  };

  const getRegin = () => {
    const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.regions}`;
    const mapCallback = (region) => ({ label: region.id, value: region.id });
    fetchData(url, "regions", setReginOptions, mapCallback);
  };

  const getPriceGroup = async () => {
    if (rangeId) {
      const rangeUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.ranges}/${rangeId}/priceGroup`;
      const list = await OAuthService.getList(rangeUrl);
      let priceGroup = list.data;
      const updatePriceGroup = {
        value: priceGroup.pgId,
        label: priceGroup.pgId,
      };
      setPriceGroupOptions([updatePriceGroup]);
    } else {
      const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.priceGroup}`;
      const list = await OAuthService.getList(url + `?size=1000&sort=pgId,asc`);
      let priceGroups = list.data?._embedded?.priceGroups || [];
      priceGroups = priceGroups.map((priceGroup) => ({
        value: priceGroup.pgId,
        label: priceGroup.pgId,
      }));
      setPriceGroupOptions(priceGroups);
    }
  };

  const getRange = async () => {
    if (vendorId) {
      const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.findRangeByVendor}?vendorId=${vendorId}`;
      const list = await OAuthService.getList(url);
      let ranges = list.data?._embedded?.ranges || [];
      ranges = ranges.map((range) => ({
        id: range.id,
        value: range.productId,
        label: range.productName,
      }));
      setRangeOptions(ranges);
    } else {
      setRangeOptions([]);
    }
  };

  const getFrontColor = () => {
    if (rangeId) {
      const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.ranges}/${rangeId}/variations`;
      const mapCallback = (mainColour) => ({
        label: `${mainColour.productId}-${mainColour.productName}`,
        value: mainColour.color,
      });
      fetchData(url, "rangeVariations", setFrontColorOptions, mapCallback);
    } else {
      setFrontColorOptions([]);
    }
  };

  const getCarcass = () => {
    const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.findAllCarcass}`;
    const mapCallback = (mainCarcass) => ({
      label: `${mainCarcass.productId}-${mainCarcass.productName}`,
      value: mainCarcass.productName,
    });
    fetchData(url, null, setCarcassOptions, mapCallback);
  };

  const getHandle = () => {
    const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.findHandles}`;
    const mapCallback = (mainHandle) => ({
      label: `${mainHandle.productId}-${mainHandle.productName}`,
      value: mainHandle.productName,
    });
    fetchData(url, null, setHandleOptions, mapCallback);
  };

  const getPort = async () => {
    const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.ports}`;
    const list = await OAuthService.getList(url);
    let allPorts = list.data?._embedded?.ports || [];
    allPorts = allPorts.map((port) => ({
      label: port.displayName,
      value: port.portCode,
      country: port.countryName,
    }));
    if (custCountry) {
      allPorts = allPorts.filter((port) => port.country === custCountry);
    }
    setPortOptions(allPorts);
  };

  const getCountries = async () => {
    const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.country}`;
    try {
      const list = await OAuthService.getList(url + `?sort=name,asc&size=1000`);
      let countries = list.data?._embedded?.countries || [];
      countries = countries.map((country) => ({
        label: country.name,
        value: country.isoCode,
      }));
      setCountryOptions(countries);
    } catch (error) {
      console.log(error.message);
    }
  };
  const getUsers = async () => {
    try {
      const list = await OAuthService.getList(usersUrl + "?size=1000");
      const users = list?.data?._embedded?.users;
      setUserOptions(
        users.map((user) => {
          return {
            value: user.email,
            label: `${user.firstName} ${user.lastName} - (${user.email})`,
          };
        }),
      );
    } catch (error) {
      console.log(error.message);
    }
  };
  const getShippingTypes = () => {
    const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.shippingTypes}`;
    const mapCallback = (shippingType) => ({
      label: shippingType.code,
      value: shippingType.code,
    });
    fetchData(url, "shippingTypes", setModeOfShipmentOptions, mapCallback);
  };
  const getAoReason = async () => {
    try {
      const list = await OAuthService.getList(aoRoReasonsUrl + `?size=1000`);
      const reasons = list.data?._embedded?.aoRoReasons;
      setReasons(
        reasons.map((item) => ({
          value: item.reason,
          label: item.reason,
          subReasons: item.subReasons || [],
        })),
      );
    } catch (error) {
      console.log(error.message);
    }
  };

  useEffect(() => {
    getOrderCategory();
    getTerritory();
    getRegin();
    getCarcass();
    getHandle();
    getPort();
    getCountries();
    getShippingTypes();
    getUsers();
    getAoReason();
  }, []);

  useEffect(() => {
    getRange();
  }, [vendorId]);
  const subReasonOptions = useMemo(() => {
    const selected = filter.partOrderReason || [];
    const options = reasons
      .filter((r) => selected.includes(r.value))
      .flatMap((r) => r.subReasons);

    return [...new Set(options)].map((s) => ({ value: s, label: s }));
  }, [reasons, filter.partOrderReason]);
  useEffect(() => {
    getFrontColor();
    getPriceGroup();
  }, [vendorId, rangeId]);

  useEffect(() => {
    getPort();
  }, [custCountry]);

  const baseStyles = customStyles("", "", "", "", "", "controlHeight");
  const selectStyleConfig = {
    ...baseStyles,
    control: (provided, state) => ({
      ...provided,
      minHeight: "30px",
      height: "30px",
      boxShadow: "none",
      border: `1px solid ${theme.palette.divider}`,
      backgroundColor: theme.palette.background.paper,
      cursor: "pointer",
      padding: "0",
    }),
    valueContainer: (provided, state) => ({
      ...provided,
      height: "28px",
      maxHeight: "28px",
      padding: "0 4px",
      display: "flex",
      flexWrap: "wrap",
      overflowY: "auto",
      overflowX: "hidden",
      alignItems: "center",
      alignContent: "flex-start",
      position: "relative",
      "&::-webkit-scrollbar": {
        width: "4px",
      },
      "&::-webkit-scrollbar-thumb": {
        backgroundColor: theme.palette.divider,
        borderRadius: "4px",
      },
    }),
    input: (provided, state) => ({
      ...provided,
      margin: "0",
      padding: "0",
      color: theme.palette.text.primary,
      fontSize: "10px",
      lineHeight: "28px",
      display: "flex",
      alignItems: "center",
    }),
    indicatorsContainer: (provided, state) => ({
      ...provided,
      height: "28px",
      padding: "0",
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      padding: "2px 4px",
      color: theme.palette.text.secondary,
    }),
    clearIndicator: (provided) => ({
      ...provided,
      padding: "2px 4px",
      color: theme.palette.text.secondary,
    }),
    placeholder: (provided, state) => ({
      ...provided,
      fontSize: "10px",
      color: theme.palette.text.secondary,
      margin: "0",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      position: "absolute",
      top: "50%",
      transform: "translateY(-50%)",
    }),
    singleValue: (provided, state) => ({
      ...provided,
      fontSize: "10px",
      color: theme.palette.text.primary,
      margin: "0",
      position: "absolute",
      top: "50%",
      transform: "translateY(-50%)",
    }),
    multiValue: (provided, state) => ({
      ...provided,
      backgroundColor:
        theme.palette.mode === "dark"
          ? "rgba(255, 255, 255, 0.15)"
          : "rgba(0, 0, 0, 0.08)", // Dynamic background for chips
      margin: "2px 2px 2px 0",
      alignItems: "center",
      borderRadius: "3px",
      flexShrink: 0,
      width: "calc(100% - 2px)",
      justifyContent: "space-between",
    }),
    multiValueLabel: (provided, state) => ({
      ...provided,
      fontSize: "9px",
      color: theme.palette.text.primary,
      padding: "2px 4px",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    }),
    multiValueRemove: (provided, state) => ({
      ...provided,
      padding: "2px",
      color: theme.palette.text.secondary,
      "&:hover": {
        backgroundColor: theme.palette.error.main,
        color: "white",
      },
    }),
    menuPortal: (provided, state) => ({
      ...provided,
      zIndex: 9999,
    }),
    noOptionsMessage: (provided, state) => ({
      ...provided,
      fontSize: "10px",
      color: theme.palette.text.secondary,
      padding: "4px 8px",
    }),
  };

  const textFieldStyleConfig = {
    "& .MuiInputBase-root": {
      height: "30px",
      minHeight: "30px",
      fontSize: "10px",
      color: theme.palette.text.primary,
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: theme.palette.divider,
      },
      "&:hover fieldset": {
        borderColor: theme.palette.text.secondary,
      },
    },
    "& .MuiOutlinedInput-input": {
      padding: "0 8px",
      height: "30px",
      lineHeight: "30px",
      boxSizing: "border-box",
    },
    "& .MuiInputBase-input::placeholder": {
      fontSize: "10px",
      color: theme.palette.text.secondary,
      opacity: 1,
      lineHeight: "30px",
    },
    width: "100%",
  };

  const checkboxConfig = {
    color: theme.palette.text.secondary,
    padding: "2px",
    "&.Mui-checked": {
      color: theme.palette.primary.main,
    },
    "& .MuiSvgIcon-root": { fontSize: 16 },
  };

  return (
    <div className="pt-4 w-full">
      <div
        className={`grid grid-cols-2 md:grid-cols-4 ${
          hasCustomerRole ? "lg:grid-cols-5" : "lg:grid-cols-8"
        } gap-4 items-center w-full`}
      >
        <Box className="w-full">
          <Select
            placeholder="Doc Type"
            type="text"
            name="orderType"
            value={
              filter.orderType &&
              OrderTypeOptions &&
              OrderTypeOptions.filter((obj) => filter.orderType === obj.value)
            }
            onChange={(e, action) => handleTypeChange(e, action, "orderType")}
            options={OrderTypeOptions}
            styles={selectStyleConfig}
            menuPortalTarget={document.body}
            isClearable
          />
        </Box>

        <Box className="w-full">
          <TextField
            sx={textFieldStyleConfig}
            placeholder="Document No"
            type="text"
            name="orderNum"
            value={filter?.orderNum}
            onChange={handleChange}
            variant="outlined"
          />
        </Box>

        <Box className="w-full">
          <Select
            placeholder="Order Category"
            name="orderCategory"
            value={orderCategoryOptions.filter((obj) =>
              filter.orderCategory?.includes(obj.value),
            )}
            onChange={(e) => handleMuiltyChange(e, "orderCategory")}
            isMulti
            options={orderCategoryOptions}
            styles={selectStyleConfig}
            menuPortalTarget={document.body}
          />
        </Box>

        <Box className="w-full">
          <Select
            type="text"
            placeholder="Category Group"
            name="categoryGroup"
            value={
              filter.categoryGroup
                ? categoryGroupOptions.find(
                    (obj) => filter.categoryGroup === obj.value,
                  )
                : null
            }
            onChange={(e, action) =>
              handleTypeChange(e, action, "categoryGroup")
            }
            options={categoryGroupOptions}
            styles={selectStyleConfig}
            menuPortalTarget={document.body}
            isClearable
          />
        </Box>

        {!hasCustomerRole && (
          <>
            <Box className="w-full">
              <Select
                placeholder="Territory"
                name="territory"
                value={territoryOptions.filter((obj) =>
                  filter.territory?.includes(obj.value),
                )}
                onChange={(e) => handleMuiltyChange(e, "territory")}
                isMulti
                options={territoryOptions}
                styles={selectStyleConfig}
                menuPortalTarget={document.body}
              />
            </Box>
            <Box className="w-full">
              <Select
                placeholder="Region"
                name="region"
                value={reginOptions.filter((obj) =>
                  filter.region?.includes(obj.value),
                )}
                onChange={(e) => handleMuiltyChange(e, "region")}
                isMulti
                options={reginOptions}
                styles={selectStyleConfig}
                menuPortalTarget={document.body}
              />
            </Box>
          </>
        )}

        <Box className="w-full">
          <Select
            placeholder="Range"
            name="mainRange"
            value={
              filter.mainRange &&
              rangeOptions &&
              rangeOptions.filter(
                (obj) => filter.mainRange.join() === obj.label,
              )
            }
            onChange={(e, action) => handleTypeChange(e, action, "mainRange")}
            options={rangeOptions}
            styles={selectStyleConfig}
            menuPortalTarget={document.body}
            noOptionsMessage={() =>
              !vendorId ? "Please select Vendor first" : "No options"
            }
            isClearable
          />
        </Box>

        <Box className="w-full">
          <Select
            placeholder="Price Group"
            name="mainPriceGrp"
            value={priceGroupOptions.filter((obj) =>
              filter.mainPriceGrp?.includes(obj.value),
            )}
            onChange={(e) => handleMuiltyChange(e, "mainPriceGrp")}
            isMulti
            options={priceGroupOptions}
            styles={selectStyleConfig}
            menuPortalTarget={document.body}
            noOptionsMessage={() =>
              !vendorId ? "Please select Vendor first" : "No options"
            }
          />
        </Box>

        <Box className="w-full">
          <Select
            placeholder="Front Colour"
            name="mainColour"
            value={frontColorOptions.filter((obj) =>
              filter.mainColour?.includes(obj.value),
            )}
            onChange={(e) => handleMuiltyChange(e, "mainColour")}
            isMulti
            options={frontColorOptions}
            styles={selectStyleConfig}
            menuPortalTarget={document.body}
            noOptionsMessage={() =>
              !vendorId ? "Please select Vendor first" : "No options"
            }
          />
        </Box>

        <Box className="w-full">
          <Select
            placeholder="Carcass"
            name="mainCarcass"
            value={carcassOptions.filter((obj) =>
              filter.mainCarcass?.includes(obj.value),
            )}
            onChange={(e) => handleMuiltyChange(e, "mainCarcass")}
            isMulti
            options={carcassOptions}
            styles={selectStyleConfig}
            menuPortalTarget={document.body}
          />
        </Box>

        <Box className="w-full">
          <Select
            placeholder="Handle"
            name="mainHandle"
            value={handleOptions.filter((obj) =>
              filter.mainHandle?.includes(obj.label),
            )}
            onChange={(e) => handleMuiltyChange(e, "mainHandle")}
            isMulti
            options={handleOptions}
            styles={selectStyleConfig}
            menuPortalTarget={document.body}
          />
        </Box>

        <Box className="w-full">
          <TextField
            sx={textFieldStyleConfig}
            placeholder="Intl Container No"
            type="text"
            name="intlContainerNum"
            value={filter.intlContainerNum}
            onChange={handleChange}
            variant="outlined"
          />
        </Box>

        <Box className="w-full">
          <TextField
            sx={textFieldStyleConfig}
            placeholder="Actl Container No"
            type="text"
            name="actualContainerNum"
            value={filter.actualContainerNum}
            onChange={handleChange}
            variant="outlined"
          />
        </Box>
        {!hasCustomerRole && (
          <>
            <Box className="w-full">
              <Select
                placeholder="country"
                name="countryCode"
                value={
                  filter.countryCode
                    ? countryOptions.find(
                        (obj) => filter.countryCode === obj.value,
                      )
                    : null
                }
                onChange={(e, action) =>
                  handleTypeChange(e, action, "countryCode")
                }
                options={countryOptions}
                styles={selectStyleConfig}
                menuPortalTarget={document.body}
              />
            </Box>

            <Box className="w-full">
              <Select
                placeholder="Port"
                name="listPort"
                value={portOptions?.filter((obj) =>
                  filter?.listPort?.includes(obj.label),
                )}
                onChange={(e) => handleMuiltyChange(e, "listPort")}
                isMulti
                options={portOptions}
                styles={selectStyleConfig}
                menuPortalTarget={document.body}
              />
            </Box>

            <Box className="w-full">
              <Select
                placeholder="Mode of shipment"
                name="freightId"
                value={modeOfShipmentOptions.filter((obj) =>
                  filter.freightId?.includes(obj.value),
                )}
                onChange={(e) => handleMuiltyChange(e, "freightId")}
                isMulti
                options={modeOfShipmentOptions}
                styles={selectStyleConfig}
                menuPortalTarget={document.body}
              />
            </Box>

            <Box className="w-full">
              <TextField
                sx={textFieldStyleConfig}
                placeholder="Tour Number"
                type="text"
                name="tourNo"
                value={filter.tourNo}
                onChange={handleChange}
                variant="outlined"
              />
            </Box>

            <Box className="w-full flex gap-4 items-center">
              <Box className="flex-1">
                <Tooltip title="PDR Status RCBL" arrow>
                  <div>
                    <Select
                      placeholder="PDR Status RCBL"
                      type="text"
                      name="pdrStatus"
                      value={
                        filter.pdrStatus &&
                        StatusOptions &&
                        StatusOptions.filter(
                          (obj) => filter.pdrStatus === obj.value,
                        )
                      }
                      onChange={(e, action) =>
                        handleTypeChange(e, action, "pdrStatus")
                      }
                      options={StatusOptions}
                      styles={selectStyleConfig}
                      menuPortalTarget={document.body}
                      isClearable
                    />
                  </div>
                </Tooltip>
              </Box>
              <Box className="flex-1">
                <Tooltip title="PDP Status PBL" arrow>
                  <div>
                    <Select
                      placeholder="PDP Status PBL"
                      type="text"
                      name="pdpStatus"
                      value={
                        filter.pdpStatus &&
                        StatusOptions &&
                        StatusOptions.filter(
                          (obj) => filter.pdpStatus === obj.value,
                        )
                      }
                      onChange={(e, action) =>
                        handleTypeChange(e, action, "pdpStatus")
                      }
                      options={StatusOptions}
                      styles={selectStyleConfig}
                      menuPortalTarget={document.body}
                      isClearable
                    />
                  </div>
                </Tooltip>
              </Box>
            </Box>
            <Box className="w-full flex gap-4 items-center">
              <Box className="flex-1">
                <Tooltip title="SDR Status" arrow>
                  <div>
                    <Select
                      placeholder="SDR Status"
                      name="sdrStatus"
                      value={statusMultiOptions.filter((obj) =>
                        filter.sdrStatus?.includes(obj.value),
                      )}
                      onChange={(e) => handleMuiltyChange(e, "sdrStatus")}
                      isMulti
                      options={statusMultiOptions}
                      styles={selectStyleConfig}
                      menuPortalTarget={document.body}
                    />
                  </div>
                </Tooltip>
              </Box>
              <Box className="flex-1">
                <Tooltip title="SDP Status" arrow>
                  <div>
                    <Select
                      placeholder="SDP Status"
                      name="sdpStatus"
                      value={statusMultiOptions.filter((obj) =>
                        filter.sdpStatus?.includes(obj.value),
                      )}
                      onChange={(e) => handleMuiltyChange(e, "sdpStatus")}
                      isMulti
                      options={statusMultiOptions}
                      styles={selectStyleConfig}
                      menuPortalTarget={document.body}
                    />
                  </div>
                </Tooltip>
              </Box>
            </Box>

            <Box className="w-full">
              <Select
                placeholder="Assigned To"
                name="assignedTo"
                value={
                  filter.assignedTo
                    ? userOptions.find((obj) => filter.assignedTo === obj.value)
                    : null
                }
                onChange={(e, action) =>
                  handleTypeChange(e, action, "assignedTo")
                }
                options={userOptions}
                styles={selectStyleConfig}
                menuPortalTarget={document.body}
              />
            </Box>

            <MultiSelectWithModal
              title="AO Reason"
              name="partOrderReason"
              options={reasons}
              filter={filter}
              onChange={handleMuiltyChange}
              styles={selectStyleConfig}
              wrapperClassName="w-full"
            />

            <MultiSelectWithModal
              title="Sub Reason"
              name="partOrderSubReason"
              options={subReasonOptions}
              filter={filter}
              onChange={handleMuiltyChange}
              styles={selectStyleConfig}
              isDisabled={!subReasonOptions.length}
              noOptionsMessage={() => "No sub reasons available"}
              wrapperClassName="w-full"
            />

            <Box
              className="w-full flex items-center h-[30px] border border-divider/40 rounded px-3"
              sx={{
                boxSizing: "border-box",
                borderColor: theme.palette.divider,
              }}
            >
              <FormControlLabel
                control={
                  <Checkbox
                    size="small"
                    sx={checkboxConfig}
                    checked={!!filter.excludeCancelled}
                    onChange={(e) =>
                      setFilter((prev) => ({
                        ...prev,
                        excludeCancelled: e.target.checked,
                      }))
                    }
                  />
                }
                label={
                  <Typography
                    variant="body2"
                    sx={{
                      whiteSpace: "normal",
                      fontSize: "10px",
                      color: theme.palette.text.primary,
                    }}
                  >
                    Exclude Cancelled
                  </Typography>
                }
                sx={{ mr: 0, ml: 0, width: "100%" }}
              />
            </Box>

            {hasSopAdminRole && (
              <Box
                className="w-full flex items-center h-[30px] border border-divider/40 rounded px-3"
                sx={{
                  boxSizing: "border-box",
                  borderColor: theme.palette.divider,
                }}
              >
                <FormControlLabel
                  control={
                    <Checkbox
                      size="small"
                      sx={checkboxConfig}
                      checked={!!filter.showDeleted}
                      onChange={(e) =>
                        setFilter((prev) => ({
                          ...prev,
                          showDeleted: e.target.checked ? true : null,
                        }))
                      }
                    />
                  }
                  label={
                    <Typography
                      variant="body2"
                      sx={{
                        whiteSpace: "normal",
                        fontSize: "10px",
                        color: theme.palette.text.primary,
                      }}
                    >
                      Show Deleted
                    </Typography>
                  }
                  sx={{ mr: 0, ml: 0, width: "100%" }}
                />
              </Box>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default memo(AdvancedSearch);
